import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { Observable } from "rxjs"
import { map, catchError } from "rxjs/operators"
import { environment } from "src/environments/environment"
import { HelpersService } from "./helpers.service"
import { Router } from "@angular/router"

@Injectable()
export class AuthService extends HelpersService {
	constructor(
		protected http: HttpClient,
		protected router: Router
	) {
		super(http, router)
	}

	public sendMessage(req): Observable<any> {
		const url = environment.DOMAIN_URL + "/api2/marketing/contact"
		return this.http.post(url, req, this.getHTTPHeader(true)).pipe(
			map(() => {
				return true
			}),
			catchError(error => {
				return this.handleError(error, "sendMessage")
			})
		)
	}

	public signUp(req): Observable<any> {
		return this.http
			.post(environment.DOMAIN_URL + "/api2/marketing/admin/user/create-soap", req, this.getHTTPHeader(true))
			.pipe(
				map(() => {
					return true
				}),
				catchError(error => {
					return this.handleError(error, "signUp")
				})
			)
	}
}
